function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.781 1.046a.538.538 0 01.438 0l6.461 2.872a.539.539 0 01-.437.984L8 2.128 1.757 4.902a.538.538 0 11-.437-.984L7.78 1.046zm-6.78 5.518c0-.297.24-.538.538-.538H14.46a.538.538 0 110 1.076h-.18v6.82h.18a.539.539 0 010 1.078H1.54a.538.538 0 110-1.077h.18v-6.82h-.18A.538.538 0 011 6.563zm1.794.538v6.82h10.41v-6.82H2.795zm2.333 1.795c.298 0 .539.241.539.539v2.153a.538.538 0 11-1.077 0V9.436c0-.298.24-.539.538-.539zm2.872 0c.297 0 .538.241.538.539v2.153a.538.538 0 11-1.076 0V9.436c0-.298.24-.539.538-.539zm2.872 0c.297 0 .538.241.538.539v2.153a.539.539 0 01-1.077 0V9.436c0-.298.241-.539.539-.539z",
  fill: "#2D2D2D"
});
function SvgBanco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Banco.svg";
export { SvgBanco as ReactComponent };